import Vue from 'vue';
import UserLoginPopup from './user-login-popup.vue';
import CheckOnLogin from './check-on-login.vue';
import { LOGIN_WITH_BOTH } from './constant';

const camelize = str => str.replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));
function getPluginName(ast, name) {
  return `$${name}${camelize(`-${ast}`)}Plugin`;
}

// 业务login插件自定义登录弹窗，平台统一调baseComponent.userLoginComponent
export default {
  /**
   * 登录
   */
  login() {
    if (window.CEIBA_ACTION_CHECK_EVENT_LOGIN) {
      Vue.prototype?.$eventBus.$emit(window.CEIBA_ACTION_CHECK_EVENT_LOGIN);
      return;
    }
    /* eslint no-underscore-dangle: 0 */
    const pullUserAreaLogin = Vue.prototype?.$eventBus?._events['ceiba:custom:events:pull-user-area-login'];
    if (pullUserAreaLogin) {
      Vue.prototype?.$eventBus.$emit('ceiba:custom:events:pull-user-area-login');
      return;
    }
    Vue.prototype?.$alert({
      msg: '请先登录',
      confirm: () => ({}),
    });
  },
  /**
   * 登录弹窗
   * @param context
   * @param option
   * @param imposeLoginType 限制登录类型
   * @param needWXLogin 端游是否需要微信登录
   * @returns {*}
   */
  showUserLoginPopup({
    context = null,
    option = {},
    imposeLoginType = LOGIN_WITH_BOTH,
    needWXLogin = false,
  } = {}) {
    const pluginName = getPluginName(Vue.prototype.$actInfo.ast, 'login');
    if (Vue.prototype?.[pluginName]?.showUserLoginPopup) {
      return Vue.prototype[pluginName].showUserLoginPopup({
        context,
        option,
        imposeLoginType,
        needWXLogin,
      });
    }
    new Promise(() => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const UserLoginPopupCreator = Vue.extend(UserLoginPopup);
      const userLoginPopup = new UserLoginPopupCreator({
        el: document.createElement('div'),
        created() {
          this.option = option;
          this.imposeLoginType = imposeLoginType;
          this.needWXLogin = needWXLogin;
          this.$on('close', () => {
            this.$destroy();
          });
          Vue.prototype?.$eventBus.$on('ceiba:custom:events:close-user-login-popup', () => this.$destroy());
          if (context) {
            // context 销毁的时候同时销毁自身
            context.$once('hook:beforeDestroy', () => this.$destroy());
          }
        },
        destroyed() {
          this.$el.remove();
        },
      });

      document.body.appendChild(userLoginPopup.$el);
    });
  },
  /**
   * 检验当前登录
   * @param context
   * @param option
   * @param params
   * @param imposeLoginType 限制登录类型
   * @returns {*}
   */
  checkOnLogin({
    context = null,
    option = {},
    imposeLoginType = LOGIN_WITH_BOTH,
  } = {}) {
    const pluginName = getPluginName(Vue.prototype.$actInfo.ast, 'login');
    if (Vue.prototype?.[pluginName]?.checkOnLogin) {
      return Vue.prototype[pluginName].checkOnLogin({
        context,
        option,
        imposeLoginType,
      });
    }
    return new Promise((resolve) => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const CheckOnLoginCreator = Vue.extend(CheckOnLogin);
      const checkOnLogin = new CheckOnLoginCreator({
        el: document.createElement('div'),
        created() {
          this.option = option;
          this.imposeLoginType = imposeLoginType;
          this.$on('check-result', (ret) => {
            console.log('checkOnLogin check-result ret = ', ret);
            this.$destroy();
            resolve(ret);
          });
          if (context) {
            // context 销毁的时候同时销毁自身
            context.$once('hook:beforeDestroy', () => this.$destroy());
          }
        },
        destroyed() {
          this.$el.remove();
        },
      });

      document.body.appendChild(checkOnLogin.$el);
    });
  },
};
